import { generacionActual } from '../utils/sesionDePeticiones.js';

const CacheService = {
    currentRequests: {},
    cachedResponses: {},
    getCachedRequest: function(service, params){
        var self = this;
        var normParams = self._normalizedParams(params);
        // #663 · Lo guardado es de la sesión que lo pidió: otra sesión no lo comparte aunque la
        // URL coincida, ni en vuelo ni ya contestado. Sin token la clave es la misma para todos.
        self._olvidarOtraSesion(service, normParams);
        if(self.currentRequests[service] && self.currentRequests[service][normParams]){
            var cachedRequest = self.currentRequests[service][normParams];
            if (cachedRequest.expirationTime > Date.now()){
                console.info("Cached request", service, params.url);
                return cachedRequest.promise;
            } else {
                delete self.currentRequests[service][normParams];
            }
        } else if (self.cachedResponses[service] && self.cachedResponses[service][normParams]){
            var cachedResponse =  self.cachedResponses[service][normParams];
            if (cachedResponse.expirationTime > Date.now()){
                console.info("Cached response", service, params.url);
                return new Promise(function(resolve, reject) {
                    if (cachedResponse.response.error) {
                        reject(cachedResponse.response);
                    } else if (cachedResponse.response.dto){
                        resolve(cachedResponse.response.dto);
                    } else {
                        resolve(cachedResponse.response);
                    }
                });
            } else {
                delete self.cachedResponses[service][normParams];
            }
        }
        return null;
    },
    addCachedRequest: function(service, params, promise){
        var self = this;
        var expiresIn = params.expiresIn;
        var expirationTime = Date.now() + expiresIn;
        var normParams = self._normalizedParams(params);
        if(!self.currentRequests[service]){
            self.currentRequests[service] = {};
        }
        var entry = {
            expirationTime: expirationTime,
            promise: promise,
            generacion: generacionActual()
        };
        self.currentRequests[service][normParams] = entry;
        // Una misma URL puede tener dos peticiones vivas: sendRequest registra aquí también las
        // que piden datos frescos (cached=false), que es como se relanza una petición colgada
        // cuando la pantalla se cansa de esperarla. Si la vieja contesta después, sin esta
        // comprobación borraría la entrada de la nueva y cachearía su respuesta obsoleta encima.
        // Una petición ya reemplazada no manda: termine como termine, aquí no toca nada.
        var vigente = function(){
            return self.currentRequests[service] && self.currentRequests[service][normParams] === entry
                && entry.generacion === generacionActual();
        };
        promise.then(function(res){
            if(!vigente()){
                console.info("Petición reemplazada. No cache", service, params.url);
                return;
            }
            delete self.currentRequests[service][normParams];
            if(res.error){
                console.log("Error. No cache");
                return;
            }
            if(!self.cachedResponses[service]){
                self.cachedResponses[service] = {};
            }
            self.cachedResponses[service][normParams] = {
                expirationTime: expirationTime,
                response: res,
                generacion: entry.generacion
            }
        }, function(err){
            if(!vigente()) return;
            delete self.currentRequests[service][normParams];
            console.log("Error. No cache");
        });
        setTimeout(function(){self._clearObsoleteCache(service,params,entry)},expiresIn);
    },
    // Se llama después de guardar, borrar o recalcular: lo que se sabía del servicio ya no vale.
    // También se olvidan las peticiones EN VUELO. Salieron antes del cambio, así que traen la foto
    // anterior: al resolverse, addCachedRequest las daría por vigentes y las cachearía encima de un
    // dato que acaba de cambiar (p.ej. el GET del mes lanzado antes de un recálculo). Olvidarlas
    // aquí hace que su vigente() sea falso y no lleguen a la caché; quien esperase esa promesa la
    // sigue recibiendo, y la siguiente petición de esa URL se lanza de nuevo en vez de compartirla.
    clearCache: function(service) {
        var self = this;
        delete self.cachedResponses[service];
        delete self.currentRequests[service];
    },
    _olvidarOtraSesion: function(service, normParams){
        const self = this;
        const gen = generacionActual();
        const enVuelo = self.currentRequests[service] && self.currentRequests[service][normParams];
        if(enVuelo && enVuelo.generacion !== gen) delete self.currentRequests[service][normParams];
        const guardada = self.cachedResponses[service] && self.cachedResponses[service][normParams];
        if(guardada && guardada.generacion !== gen) delete self.cachedResponses[service][normParams];
    },
    _clearObsoleteCache: function(service, params, entry){
        var self = this;
        var normParams = self._normalizedParams(params);
        if(!self.currentRequests[service]) return;
        // Solo caduca la suya: si mientras tanto se relanzó la petición, la entrada de aquí es la
        // de la nueva y todavía le queda tiempo.
        if(entry && self.currentRequests[service][normParams] !== entry) return;
        delete self.currentRequests[service][normParams];
    },
    _normalizedParams: function(a){
        function sortProperties(unordered){
            var ordered = {};
            Object.keys(unordered).sort().forEach(key=>{ordered[key] = unordered[key]});
            return ordered;
        }
        return JSON.stringify(sortProperties(a));
    },
    _isEqual: function (a,b){
        return self._normalizedParams(a) == self._normalizedParams(b);
    }
}

export default CacheService;